import { useState } from 'react';
import Display from './Display';
import Keypad from './Keypad';

const Calculator = () => {
  const [calObj, setCalObj] = useState({
    total: null,
    next: null,
    operation: null,
  });

  return (
    <section className="calculator">
      <Display value={calObj.next || calObj.total || '0'} />
      <Keypad setCalObj={setCalObj} calObj={calObj} />
    </section>
  );
};

export default Calculator;
